import React from 'react';
import BlockQuote from '../BlockQuote';
import Button, { ILink } from 'tbk-components/src/components/Button';
import { useTranslation } from 'react-i18next';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import cn from 'classnames';

// We use plain text to fill product content for now.
// Once product CPT is set up, we can use a product selector to fill the content.
// See similar method in LogoBar.
export interface ProductDetails {
	name?: string;
	description?: string;
	link?: ILink;
}

export interface IProductUsedProps extends IBaseElementProps {
	id;
	classname;
	classNames;
	product?: ProductDetails;
	blockQuote?: string;
}

/**
 * Calian Product used
 * @block
 */
const ProductUsed: React.FC<IProductUsedProps> = ({
	id,
	classname,
	classNames = [],
	product,
	blockQuote,
}) => {
	const { t } = useTranslation();
	return (
		<div
			id={id}
			className={
				classname || cn('product-used__container', ...classNames)
			}
		>
			<span>{t('Product Used')}:</span>
			<div className="product-used__container-inner">
				<div className="product-used__left">
					{product?.link?.href && (
						<Button
							{...product.link}
							className="product-used__product"
						>
							{product?.name && <span>{product?.name}</span>}
							{product?.description && (
								<p>{product?.description}</p>
							)}
							<i className="icon icon-arrow-right1"></i>
						</Button>
					)}
				</div>
				<div className="product-used__right">
					{blockQuote && <BlockQuote quote={blockQuote} />}
				</div>
			</div>
		</div>
	);
};

export default ProductUsed;
